<template>
    <div class="form-group">
        <label>Nome <span class="text-danger" v-if="showAsterisks">*</span></label>
        <input type="text" class="form-control" v-model="localValue.name" />
    </div>
    <div class="form-group">
        <label>Cognome <span class="text-danger" v-if="showAsterisks">*</span></label>
        <input type="text" class="form-control" v-model="localValue.surname" />
    </div>
    <div class="form-group">
        <label>Nome azienda (Compare nelle commesse condivise con altri utenti)</label>
        <input type="text" class="form-control" v-model="localValue.companyName" />
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { ModalServices } from '@/services/ModalServices';
import { LoginClient, UserClient } from '@/services/Services';
import { mixins, Options, Vue } from 'vue-class-component';
import store from '@/store';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class personalData extends mixins(WithModel) {

    declare localValue: OM.PersonalData;

    @Prop({
        default: false
    }) showAsterisks: boolean;

}
</script>
